import React from "react";
import PageTitle from "../../components/common/PageTitle";

const MembersOverview = () => (
  <>
    <PageTitle title="Members Overview" />
  </>
);

export default MembersOverview;
